// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"4b4431cd","498":"4cb160a0","513":"ea7861be","787":"c4f22d66"}[chunkId] + ".chunk.js";
};